import { render, staticRenderFns } from "./PhotopointAdd.vue?vue&type=template&id=684db715&scoped=true&"
import script from "./PhotopointAdd.vue?vue&type=script&lang=js&"
export * from "./PhotopointAdd.vue?vue&type=script&lang=js&"
import style0 from "./PhotopointAdd.vue?vue&type=style&index=0&id=684db715&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684db715",
  null
  
)

export default component.exports